import { pagesService } from '@/_services'


export const pages = {
  namespaced: true,
  state: {
    pages:[]
  },
  getters: {
    getPageByAlias: state => alias => {
      return state.pages.find(pages => pages.alias === alias);
    }
  },
  mutations: {
    setPages(state, payload) {
      state.pages = payload;
    },
  },
  actions: {
    loadPagesList({commit}) {
      pagesService.loadPagesList().then(data=>{
        commit('setPages',data)
      })
    },
    
  }
}